/*
  Various utilities for dealing with timeseries data
  particularly the TimeSeriesResult and TimeSeries from
  https://github.com/Contrast-Security-Inc/teamserver/blob/develop/teamserver-app/src/main/resources/openapi/application-security-summary.openapi.yaml

  used internally for newer vuln charts
*/

// TimeSeries fields index constants to enable readable code
export const fieldIndex = {
  start: 0,
  end: 1,
  count: 2,
  // psuedo field name for readability and consistency (configured in 1 location)
  // field used to represent x axis (start or end)
  x: 1
}

// get a series from TimeSeriesResult or fall back to a generic empty series
export const getSeries = (id, timeline) =>
  timeline?.find((it) => it.id === id) || { id, values: [] }

// get a group of series by category id groups and associate a label to each
export const getCategorySeries = (categories, labels, timeline) =>
  categories.reduce((obj, category, index) => {
    obj[category] = getSeries(category, timeline)
    obj[category].label = labels[index]

    return obj
  }, {})

// get value at specific x coordinate of a series.values array
export const getValueAtX = (values, x) =>
  values.find((it) => it[fieldIndex.x] === x)?.[fieldIndex.count] || 0

export const TIMELINE_RESOLUTIONS = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
}

// maps resolution to xAxis.tickInterval
const MILLISECONDS_IN_DAY = 24 * 3600 * 1000
export const RESOLUTION_TO_TICK_INTERVAL_MAP = {
  [TIMELINE_RESOLUTIONS.DAILY]: MILLISECONDS_IN_DAY,
  [TIMELINE_RESOLUTIONS.WEEKLY]: 7 * MILLISECONDS_IN_DAY,
  [TIMELINE_RESOLUTIONS.MONTHLY]: 28 * MILLISECONDS_IN_DAY
}
/*
 * Provides business logic for stride and resolution parameters
 * Exported strictly for testing, use getTimelineConfigByDays for working with this configuration
 * Max range is 366 days accounting for leaps
 */
export const timelineConfig = [
  { days: 12, stride: 1, resolution: TIMELINE_RESOLUTIONS.DAILY },
  { days: 15, stride: 2, resolution: TIMELINE_RESOLUTIONS.DAILY },
  { days: 31, stride: 4, resolution: TIMELINE_RESOLUTIONS.DAILY },
  { days: 84, stride: 1, resolution: TIMELINE_RESOLUTIONS.WEEKLY },
  { days: 105, stride: 2, resolution: TIMELINE_RESOLUTIONS.WEEKLY },
  { days: 366, stride: 1, resolution: TIMELINE_RESOLUTIONS.MONTHLY }
]

// returns the timeline configuration for a specific day range
export const getTimelineConfigByDays = (days) => {
  const config = timelineConfig.find((it) => days <= it.days)

  if (!config) {
    throw new RangeError('days parameter is out of range.')
  }

  return config
}
